import {useEffect, useMemo} from 'react';
import {ModuleTopic} from '@cp/model';
import enrichTopicWithParent from './enrich/enrichTopicWithParent';
import mapModuleTopicToTopicId from './map/mapModuleTopicToTopicId';

function mapTopicOnlyToTopicString(moduleTopics: ModuleTopic[], topicsOnly: string[]): string[] {
  // Optimized: Use Set for O(1) lookup instead of O(n) includes check
  const topicsSet = new Set(topicsOnly);
  return moduleTopics
    .filter((moduleTopic) => topicsSet.has(moduleTopic.topic))
    .map((moduleTopic) => mapModuleTopicToTopicId(moduleTopic));
}

/**
 * Convert selected topic string to category|topic format
 * then set the internal selected topics
 * @param moduleTopics - The module topics to convert
 * @param selectedTopics - The selected topics to convert
 * @returns The converted selected topics
 */
export default function useTopicSelectionSelectedItems(
  moduleTopics: ModuleTopic[],
  selectedTopics: string[],
  childTopicStrings: string[],
  setInitialTopics: (categoryTopics: string[]) => void,
) {
  // convert selected topics only to topic string
  const selectedTopicStrings = useMemo(
    () => mapTopicOnlyToTopicString(moduleTopics, selectedTopics),
    [moduleTopics, selectedTopics],
  );

  // Initialize internal state when selectedTopics prop changes
  useEffect(() => {
    const enrichedTopics = enrichTopicWithParent(selectedTopicStrings, childTopicStrings);
    setInitialTopics(enrichedTopics);
  }, [selectedTopics, selectedTopicStrings, childTopicStrings, setInitialTopics]);
}
